export default "__VITE_ASSET__CtIU$NNo__"